import {
  ADMIN_TOKEN_NAME,
  STORE_USER,
  SET_USERS,
  SELECT_USER,
  SET_APPROVERS,
  SELECT_APPROVER,
  SET_SEEDS,
  SELECT_SEED,
  SET_WHITELIST,
  SELECT_WHITELIST,
  SET_SUPPRESSIONLIST,
  SELECT_SUPPRESSIONLIST,
  ADMIN_ERROR,
  ADMIN_LOADING,
} from "../constants";

const initial_state = {
  loading: {
    users: false,
    approvers: false,
    seedLists: false,
    whitelist: false,
    suppressionlist: false,
  },
  errors: {},

  // Users
  users: [], // List of available users
  selectedUser: {}, // Selected User
  token: localStorage.getItem(ADMIN_TOKEN_NAME) || "", // THIS admin token - stored for impersonation

  // Approvers
  approvers: [],
  selectedApprover: {},

  // Seeds
  seedLists: [],
  selectedSeed: {},

  // Whitelist
  whitelist: [],
  selectedWhitelist: {},
  whitelistInternal: false,

  // suppressionlist
  suppressionlist: [],
  selectedSuppressionlist: {},
  searchsuppression: {},
};

export default function (state = initial_state, { type, payload }) {
  const loading = state.loading;

  switch (type) {
    case ADMIN_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case ADMIN_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };

    case STORE_USER:
      if (!localStorage.getItem(ADMIN_TOKEN_NAME)) {
        localStorage.setItem(ADMIN_TOKEN_NAME, payload.token);

        return {
          ...state,
          ...payload,
        };
      }

      return state;

    case SET_USERS:
      loading.users = false;

      return {
        ...state,
        loading,
        users: payload,
      };

    case SELECT_USER:
      return {
        ...state,
        selectedUser: payload,
      };

    case SET_APPROVERS:
      loading.approvers = false;

      return {
        ...state,
        loading,
        approvers: payload,
      };

    case SELECT_APPROVER:
      return {
        ...state,
        selectedApprover: payload,
      };

    case SET_SEEDS:
      loading.seedLists = false;
      return {
        ...state,
        loading,
        seedLists: payload,
      };

    case SELECT_SEED:
      return {
        ...state,
        selectedSeed: payload,
      };

    case SET_WHITELIST:
      loading.whitelist = false;
      return {
        ...state,
        loading,
        whitelist: payload.whitelist,
        whitelistInternal: payload.internal_user,
      };

    case SELECT_WHITELIST:
      return {
        ...state,
        selectedWhitelist: payload,
      };

    case SET_SUPPRESSIONLIST:
      loading.suppressionlist = false;
      return {
        ...state,
        loading,
        suppressionlist: payload.suppressionlist || [],
        searchsuppression: payload.searchsuppression || {},
        suppressionAllCount: payload.searchCount || 0,
      };

    case SELECT_SUPPRESSIONLIST:
      return {
        ...state,
        selectedSuppressionlist: payload,
      };

    default:
      return state;
  }
}
